'use strict';

/**
 * Populate the Billing Address Summary View
 * @param {string} parentSelector - the top level DOM selector for a unique address summary
 * @param {Object} address - the address data
 */
function populateAddressSummary(parentSelector, address) {
    $.each(address, function (attr) {
        var val = address[attr];
        $('.' + attr, parentSelector).text(val || '');
    });
}

/**
 * returns a formed <option /> element
 * @param {Object} shipping - the shipping object (shipment model)
 * @param {boolean} selected - current shipping is selected (for PLI)
 * @param {order} order - the Order model
 * @param {Object} [options] - options
 * @returns {Object} - the jQuery / DOMElement
 */
function optionValueForAddress(shipping, selected, order, options) {
    var safeOptions = options || {};
    var isBilling = safeOptions.type && safeOptions.type === 'billing';
    var className = safeOptions.className || '';
    var isSelected = selected;
    var isNew = !shipping;
    if (typeof shipping === 'string') {
        return $('<option class="' + className + '" disabled>' + shipping + '</option>');
    }
    var safeShipping = shipping || {};
    var shippingAddress = safeShipping.shippingAddress || {};

    if (isBilling && isNew && !order.billing.matchingAddressId) {
        shippingAddress = order.billing.billingAddress.address || {};
        isNew = false;
        isSelected = true;
        safeShipping.UUID = 'manual-entry';
    }

    var uuid = safeShipping.UUID ? safeShipping.UUID : 'new';
    var optionEl = $('<option class="' + className + '" />');
    optionEl.val(uuid);

    var title;

    if (isNew) {
        title = order.resources.addNewAddress;
    } else {
        title = [];
        if (shippingAddress.firstName) {
            title.push(shippingAddress.firstName);
        }
        if (shippingAddress.lastName) {
            title.push(shippingAddress.lastName);
        }
        if (shippingAddress.address1) {
            title.push(shippingAddress.address1);
        }
        if (shippingAddress.address2) {
            title.push(shippingAddress.address2);
        }
        if (shippingAddress.city) {
            if (shippingAddress.state) {
                title.push(shippingAddress.city + ',');
            } else {
                title.push(shippingAddress.city);
            }
        }
        if (shippingAddress.stateCode) {
            title.push(shippingAddress.stateCode);
        }
        if (shippingAddress.postalCode) {
            title.push(shippingAddress.postalCode);
        }
        if (!isBilling && safeShipping.selectedShippingMethod) {
            title.push('-');
            title.push(safeShipping.selectedShippingMethod.displayName);
        }

        if (title.length > 2) {
            title = title.join(' ');
        } else {
            title = order.resources.newAddress;
        }
    }
    optionEl.text(title);

    var keyMap = {
        'data-first-name': 'firstName',
        'data-last-name': 'lastName',
        'data-company-name': 'companyName',
        'data-address1': 'address1',
        'data-address2': 'address2',
        'data-city': 'city',
        'data-state-code': 'stateCode',
        'data-postal-code': 'postalCode',
        'data-country-code': 'countryCode',
        'data-phone': 'phone'
    };
    $.each(keyMap, function (key) {
        var mappedKey = keyMap[key];
        var mappedValue = shippingAddress[mappedKey];
        // In case of country code
        if (mappedValue && typeof mappedValue === 'object') {
            mappedValue = mappedValue.value;
        }

        optionEl.attr(key, mappedValue || '');
    });

    var giftObj = {
        'data-is-gift': 'isGift',
        'data-gift-message': 'giftMessage'
    };

    $.each(giftObj, function (key) {
        var mappedKey = giftObj[key];
        var mappedValue = safeShipping[mappedKey];
        optionEl.attr(key, mappedValue || '');
    });

    if (isSelected) {
        optionEl.attr('selected', true);
    }

    return optionEl;
}

/**
 * returns address properties from a UI form
 * @param {Form} form - the Form element
 * @returns {Object} - a JSON object with all values
 */
function getAddressFieldsFromUI(form) {
    var stateCode = $('select[name$=_stateCode],input[name$=_stateCode]', form).val();
    var address;
    if ($('.js-payment-methods .payment-information') && $('.js-payment-methods .payment-information').attr('data-payment-method-id')==='AMAZON_PAY') {
        var stateCodeVal = $('select[name$=_stateCode]', form).find('option.selected').attr('id');
        address = {
            firstName: $('input[name$=_firstName]', form).data('value'),
            lastName: $('input[name$=_lastName]', form).data('value'),
            address1: $('input[name$=_address1]', form).data('value'),
            address2: $('input[name$=_address2]', form).data('value'),
            city: $('input[name$=_city]', form).data('value'),
            postalCode: $('input[name$=_postalCode]', form).data('value'),
            stateCode: (stateCodeVal === 'NONE') || (stateCodeVal === '') || (stateCodeVal === null) ? 'NONE' : stateCodeVal,
            countryCode: $('select[name$=_country]', form).find('option.selected').attr('id') || $('select[name$=_country]', form).data('countrycode'),
            phone: $('input[name$=_phone]', form).data('value')
        };

    }else{
        address = {
            firstName: $('input[name$=_firstName]', form).val(),
            lastName: $('input[name$=_lastName]', form).val(),
            companyName: $('input[name$=_companyName]', form).val(),
            address1: $('input[name$=_address1]', form).val(),
            address2: $('input[name$=_address2]', form).val(),
            city: $('input[name$=_city]', form).val(),
            postalCode: $('input[name$=_postalCode]', form).val(),
            stateCode: (stateCode === 'NONE') || (stateCode === '') || (stateCode === null) ? 'NONE' : stateCode,
            countryCode: $('select[name$=_country]', form).val(),
            phone: $('input[name$=_phone]', form).val()
        };
    }

    return address;
}

function getCityState() {
    // Retrieve and autofill city name if zip code is manually entered for US addresses
    // Otherwise city should already be filled out via Google AVS
    $('.js-zipCode').on('input', function () {
        var url = $(this).data('citystateurl');
        var zipCode = $(this).val();
        var country;
        if ($('.js-payment-methods .payment-information') && $('.js-payment-methods .payment-information').attr('data-payment-method-id')==='AMAZON_PAY') {
            country =  $(this).closest('.js-address').find('select.js-country').find('option.selected').attr('id');
        }else{
            country = $(this).closest('.js-address').find('select.js-country').val();
        }

        if (zipCode && zipCode.length == 5 && country == 'US') {
            var cityField = $(this).closest('.js-address').find('.js-cityField');
            var stateField = $(this).closest('.js-address').find('.js-state');

            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                data: { zipCode: zipCode },
                success: function (response) {
                    cityField.val(response.cityName);
                    stateField.selectpicker('val', response.state).trigger('change');
                }
            });
        }
    })
}

function updateStateOptions() {
    var updateShippingMethodList = require('./shipping').methods.updateShippingMethodList;
    $('.js-country').on('change', function () {
        var country;
        var state;
        if ($('.js-payment-methods .payment-information') && $('.js-payment-methods .payment-information').attr('data-payment-method-id')==='AMAZON_PAY') {
            country =  $(this).find('option.selected').attr('id');
            state = $(this).closest('.js-address').find('select.js-state').find('option.selected');
        } else {
            country = $(this).val();
            state = $(this).closest('.js-address').find('select.js-state');
        }
        var url = $(this).data('url');
        var currentState = state.val();

        if (!currentState) {
            currentState = state.data('statecode');
        }
        state.removeAttr('data-statecode');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            async: false,
            data: {
                country: country
            },
            success: function (data) {
                if (data.stateOptionsHTML && data.stateOptionsHTML.length > 0) {
                    state.selectpicker('destroy');
                    state.html(data.stateOptionsHTML);
                    state.selectpicker('render');
                    state.addClass('selectpicker');

                    if (country != 'US' && country != 'CA') {
                        currentState = 'NONE';
                    } else if( !currentState || currentState === 'NONE') {
                        currentState = state.find('option:first').val();
                    }
                    if (currentState && currentState.length && state.find('option[value='+currentState+']').length) {
                        state.selectpicker('val', currentState);
                    }

                    if (currentState !== '') {
                        state.trigger('change');
                    } else {
                        if (state.parents('form.shipping-form').length) {
                            updateShippingMethodList(state.parents('form.shipping-form'));
                        }
                    }

                    // Update billing address as well
                    var sameShippingBilling = $('.js-billing-shipping-same');
                    if (sameShippingBilling && sameShippingBilling.length > 0 && sameShippingBilling.is(':checked')) {
                        var billingState = $('.billing-address').find('select.js-state');
                        billingState.selectpicker('destroy');
                        billingState.html(data.stateOptionsHTML);
                        billingState.selectpicker('render');
                        billingState.addClass('selectpicker');

                        if (currentState && currentState.length) {
                            billingState.selectpicker('val', currentState);
                        }
                    }
                }
            }
        });
        handleInternationalAddress($(this).closest('.js-avs-autocomplete'));
    });
}

function validateZipCode(addressForm) {
    var countryValue = addressForm.find('select.js-country').val();
    var postalCode = addressForm.find('.js-zipCode');
    var zipCodeUSRegex = /^\d{5}(-\d{4})?$/;
    var invalidMsgContainer = postalCode.closest('.form-group').find('.invalid-feedback');

    if (countryValue == 'US') {
        if (zipCodeUSRegex.test(postalCode.val()) == false) {
            postalCode.addClass('is-invalid');
            invalidMsgContainer.text('Please enter a valid zip code');
        } else {
            postalCode.removeClass('is-invalid');
            invalidMsgContainer.text('');
        }
    } else {
        postalCode.removeClass('is-invalid');
        invalidMsgContainer.text('');
    }
}

function handleInternationalAddress(containerEle) {
    var $addressContainer = containerEle;
    var country = $addressContainer.find('select.js-country').val();
    var isInternationalShipping = (country !== 'US');
    var isShippingToCanada = (country === 'CA');

    $addressContainer.find('.js-internationalShipping, .js-internationalBilling').prop('checked', isInternationalShipping).trigger('change');

    // Toggle Mandatory fields based on address
    var shipState = $addressContainer.find('select.js-state');
    var invalidShipText = shipState.parents('.form-group').find('.invalid-feedback');
    invalidShipText.addClass('d-block');

    if (isInternationalShipping && !isShippingToCanada) {
        shipState.prop('required', false).parents('.form-group').removeClass('required');
        shipState.removeClass('is-invalid');
        shipState.parents('.form-group').removeClass('is-invalid');
        shipState.parents('.form-control').removeClass('is-invalid');
        invalidShipText.removeClass('d-block');
    } else {
        if ($addressContainer.find('select.js-state.is-invalid').length > 0) {
            invalidShipText.addClass('d-block');
        } else {
            invalidShipText.removeClass('d-block');
        }
        $addressContainer.find('.js-postal_code, .js-locality, select.js-state').prop('required', true).parents('.form-group').addClass('required');
    }


    if ($('.js-billing-shipping-same').is(":checked")) {
        // Toggle mandatory fields
        var billState = $('select.billingState');
        var invalidBillText = billState.parents('.form-group').find('.invalid-feedback');

        if (isInternationalShipping && !isShippingToCanada) {
            billState.prop('required', false).parents('.form-group').removeClass('required');
            billState.removeClass('is-invalid');
            billState.parents('.form-group').removeClass('is-invalid');
            billState.parents('.form-control').removeClass('is-invalid');
            invalidBillText.removeClass('d-block');

        } else {
            if ($('select.billingState.is-invalid').length > 0) {
                invalidBillText.addClass('d-block');
            } else {
                invalidBillText.removeClass('d-block');
            }
            invalidBillText.removeClass('d-block');
            $('.billingZipCode, .billingAddressCity, select.billingState').prop('required', true).parents('.form-group').addClass('required');
        }
    }
}

function preventInputByRegex(event, regex) {
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
        event.preventDefault();
        return false;
    }
}

function preventCharByPaste(e,regex){
    var pastedData = e.originalEvent.clipboardData.getData('text');
            if (regex.test(pastedData) !== true) {
            e.preventDefault();
        }
}

module.exports = {
    methods: {
        populateAddressSummary: populateAddressSummary,
        optionValueForAddress: optionValueForAddress,
        getAddressFieldsFromUI: getAddressFieldsFromUI,
        getCityState: getCityState,
        updateStateOptions: updateStateOptions,
        handleInternationalAddress: handleInternationalAddress,
        preventInputByRegex: preventInputByRegex,
        preventCharByPaste:preventCharByPaste
    },

    showDetails: function () {
        $('.btn-show-details').on('click', function () {
            event.preventDefault();
            var form = $(this).closest('form');

            form.attr('data-address-mode', 'details');
            form.find('.multi-ship-address-actions').removeClass('d-none');
            form.find('.multi-ship-action-buttons .col-12.btn-save-multi-ship').addClass('d-none');
        });
    },

    addNewAddress: function () {
        $('.btn-add-new').on('click', function () {
            event.preventDefault();
            var $el = $(this);
            if ($el.parents('#dwfrm_billing').length > 0) {
                // Handle billing address case
                $('body').trigger('checkout:clearBillingForm');
                var $option = $($el.parents('form').find('.addressSelector option')[0]);
                $option.attr('value', 'new');
                var $newTitle = $('#dwfrm_billing input[name=localizedNewAddressTitle]').val();
                $option.text($newTitle);
                $option.prop('selected', 'selected');
                $el.parents('[data-address-mode]').attr('data-address-mode', 'new');
            } else {
                // Handle shipping address case
                $('.js-shippingCountry.js-country').val('US');  //On 'ADD NEW' shipping address, default address is 'US'
                $('.shipping-address-block .shippingPhoneNumber').val('');
                var $newEl = $el.parents('form').find('.addressSelector option[value=new]');
                $newEl.prop('selected', 'selected');
                $newEl.parent().trigger('change');
            }
        });
    },

    validatePostalCodeUpdates: function () {
        $('.js-country').on('blur', function () {
            var addressForm = $(this).closest('.js-address');
            validateZipCode(addressForm);
        });

        $('.js-zipCode').on('input change', function () {
            var addressForm = $(this).closest('.js-address');
            validateZipCode(addressForm);
        });
    },

    preventUnwantedInput: function () {
        $('.shippingFirstName, .billingFirstName, .shippingLastName, .billingLastName').on('keyup', function (e) {
            $(this).val($(this).val().replace(/[^a-zA-Z ]/g, ''));
            preventInputByRegex(e, new RegExp("^([a-zA-Z ])$"));
        });
        $('.shippingFirstName, .billingFirstName, .shippingLastName, .billingLastName').on('paste', function (e) {
            $(this).val($(this).val().replace(/[^a-zA-Z ]/g, ''));
            preventCharByPaste(e, /[a-zA-Z]$/);
        });
        $('.shippingFirstName, .billingFirstName, .shippingLastName, .billingLastName').on('blur', function (e) {
            var value = $(this).val();
            if(/^[a-zA-Z ]*$/.test(value) == false) {
                $(this).addClass('alt-error is-invalid');
            } else {
                $(this).removeClass('alt-error');
            }
        });

        $('.js-street_number, .shippingAddressTwo, .companyName').on('keypress', function (e) {
            preventInputByRegex(e, new RegExp("^([A-Za-z0-9 #\.,\-/])+$"));
        });

        $('.js-street_number, .shippingAddressTwo, .companyName').on('blur', function (e) {
            var value = $(this).val();
            if(/^[A-Za-z0-9 #\.,\-/]*$/.test(value) == false) {
                $(this).addClass('alt-error is-invalid');
            } else {
                $(this).removeClass('alt-error');
            }
        });

        $('.js-street_number').on('blur', function (e) {
            var value = $(this).val();
            if(/.*\S.*/.test(value) == false 
                &&  $('#checkout-main').attr('data-customer-type') === 'registered'
                && $('select.addressSelector').val() !== 'new' && !$(this).hasClass('billingAddressOne')) {
                $('.btn-add-new').trigger('click');
            }
        });

        $('.js-zipCode').on('keypress', function (e) {
            preventInputByRegex(e, new RegExp("^([a-zA-Z0-9 \-])$"));
        });

        $('.js-zipCode').on('blur', function (e) {
            var value = $(this).val();
            // if(/^[a-zA-Z0-9 \-]*$/.test(value) == false) {
            if (/^[a-zA-Z0-9-,.&*#!@()? ]*$/.test(value) == false) {
                $(this).addClass('alt-error is-invalid');
            } else if (value === '') {
                $(this).addClass('alt-error is-invalid');
                $(this).trigger('invalid', this.validity);
            } else {
                $(this).removeClass('alt-error');
            }
        });

        $('.js-cityField').on('keypress', function (e) {
            preventInputByRegex(e, new RegExp("^([a-zA-Z \-\.])$"));
        });

        $('.js-cityField').on('blur', function (e) {
            var value = $(this).val();
            if(/^[a-zA-Z \-\.]*$/.test(value) == false) {
                $(this).addClass('alt-error is-invalid');
            } else {
                $(this).removeClass('alt-error');
            }
        });
    }
};
